import { ActionRunner } from "applesauce-actions";

import { eventStore } from "./stores";
import { accounts } from "./accounts";
import { publish } from "./pool";

// The action runner is used to run Actions against the event store.
export const actions = new ActionRunner(eventStore, accounts.signer, publish);
